import React, { useState, useContext, useEffect } from 'react';
import 'react-dates/initialize';
import DayPickerRangeController from 'react-dates/lib/components/DayPickerRangeController';
import isInclusivelyAfterDay from 'react-dates/lib/utils/isInclusivelyAfterDay';
import moment from 'moment';
import FilterButton from '../FilterButton';
import { EventMapContext } from '../../context/EventMapContext';
import DatepickerArrow from '../DatepickerArrow';
import useWindowSize from '../../hooks/useWindowSize';
import WindowQuery from '../../utils/WindowQuery';
import { queryDateFormat } from '../../constants/formats.json';

const EventDateFilter = ({ visible }) => {
  const updateQuery = new WindowQuery();

  const {
    setCurrentPage,
    startDate,
    endDate,
    setStartDate,
    setEndDate,
    setDropdown,
  } = useContext(EventMapContext);

  const { width: windowWidth } = useWindowSize();

  const [focusedInput, setFocusedInput] = useState('startDate');
  const [localStartDate, setLocalStartDate] = useState(null);
  const [localEndDate, setLocalEndDate] = useState(null);
  // Changes date formats to graphql format. Should be made into a util as it is used elsewhere.

  useEffect(() => {
    if (startDate && endDate) {
      setLocalStartDate(moment(startDate));
      setLocalEndDate(moment(endDate));
    } else {
      setLocalStartDate(null);
      setLocalEndDate(null);
    }
  }, [endDate, startDate]);

  const handleFocusChange = newFocusedInput => {
    if (!newFocusedInput) {
      setFocusedInput('startDate');
    } else {
      setFocusedInput(newFocusedInput);
    }
  };

  // Prevents date picker from rendering before container width is set
  if (!visible) {
    return null;
  }

  return (
    <div className="event-date-filter_ custom-calendar-wrapper">
      <DayPickerRangeController
        minimumNights={0}
        isOutsideRange={day => !isInclusivelyAfterDay(day, moment())}
        startDate={localStartDate || null}
        endDate={localEndDate || null}
        onDatesChange={({ startDate: newStartDate, endDate: newEndDate }) => {
          setLocalStartDate(newStartDate);
          setLocalEndDate(newEndDate);
        }}
        numberOfMonths={windowWidth <= 630 ? 1 : 2}
        focusedInput={focusedInput}
        onFocusChange={handleFocusChange}
        noBorder
        navNext={<DatepickerArrow direction="next" />}
        navPrev={<DatepickerArrow direction="prev" />}
      />
      <div className="dropdown-actions calendar-filter-buttons">
        <button
          aria-label="Apply Date Filters"
          name="Apply Date Filters"
          type="button"
          className="btn btn--dark btn--small"
          onClick={() => {
            if (localStartDate)
              updateQuery.add(
                'start_date',
                localStartDate.format(queryDateFormat)
              );
            if (localEndDate)
              updateQuery.add('end_date', localEndDate.format(queryDateFormat));
            setStartDate(localStartDate);
            setEndDate(localEndDate);
            setCurrentPage(1);
            setDropdown(null);
          }}
        >
          Apply
        </button>
        <button
          aria-label="Clear Date Filter"
          name="Clear Date Filter"
          onClick={() => {
            if (localStartDate) updateQuery.remove('start_date');
            if (localEndDate) updateQuery.remove('end_date');
            setLocalStartDate(null);
            setLocalEndDate(null);
            setStartDate(null);
            setEndDate(null);
          }}
          className="btn btn--light btn--small"
          type="button"
        >
          Clear
        </button>
      </div>
    </div>
  );
};

export default EventDateFilter;
